import './assets/Skeleton.css';const t = "_skeleton_14s8y_4", s = "_pulse_14s8y_1", _ = "_circle_14s8y_17", e = "_button_14s8y_24", c = "_heading_14s8y_30", n = "_text_14s8y_34", o = "_cta_14s8y_46", l = {
  skeleton: t,
  pulse: s,
  circle: _,
  button: e,
  heading: c,
  text: n,
  cta: o
};
export {
  l as s
};
